"use strict";
window.breakpoints = {
    large: 1024,
    medium: 640,
    small: 0,
    xlarge: 1200,
    xxlarge: 1440,
};
